:host {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 100%;
    position: relative;
}

.node {
    padding: 20px;
    color: var(--color-layout-contrast);
    outline-offset: -4px;
    white-space: nowrap;

    &::after {
        content: '';
        display: block;
        position: absolute;
        background-color: currentColor;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: auto;
        transition:
            transform 500ms ease,
            opacity 500ms ease;
        opacity: 0;
        top: 100%;
        right: 0;
        bottom: unset;
        left: 0;
    }

    &:hover,
    &:focus {
        color: var(--color-layout-highlight);

        &::after {
            transform: translateY(-5px);
            opacity: 0.5;
        }
    }

    &[disabled] {
        &:hover,
        &:focus,
        & {
            color: var(--color-layout-contrast);

            &::after {
                display: none;
            }
        }
    }
}

:host(.open) .node::after,
:host(.active_within) .node::after,
.link-active.node::after {
    color: var(--color-layout-highlight);
    transform: translateY(-10px);
    opacity: 1;
}

nav {
    display: none;
    position: absolute;
    left: 10px;
    top: 100%;
    flex-direction: column;
    border: 1px solid var(--color-layout-shade-20);
    border-top: 2px solid var(--color-layout-highlight);
    background-color: var(--color-layout-shade-20);
    min-width: 200px;
    overflow: hidden;
    transition: height 300ms ease;
}

:host(.visible) nav {
    display: flex;
}
